import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { take } from 'rxjs/operators';

import { AuthenticationSandbox } from '../../sandbox/authentication.sandbox';

@Component({
    standalone: false,
    selector: 'med-logout-container',
    template: ''
})
export class LogoutContainerComponent implements OnInit {
    constructor(
        private readonly sandbox: AuthenticationSandbox,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.logout();
    }

    private logout(): void {
        this.sandbox.logout();

        // Use internal login if offline
        if (this.sandbox.isOfflineEnvironment()) {
            this.router.navigate(['/login']);
        } else {
            this.navigateToOauthLogoutPage();
        }
    }

    private navigateToOauthLogoutPage(): void {
        this.sandbox
            .getOauthLogoutUrl()
            .pipe(take(1))
            .subscribe(logoutUrl => {
                window.location.href = logoutUrl;
            });
    }
}
